import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=3fdb1343&scoped=true&"
import script from "./MaterialCard.vue?vue&type=script&lang=js&"
export * from "./MaterialCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCard.vue?vue&type=style&index=0&id=3fdb1343&prod&lang=sass&"
import style1 from "./MaterialCard.vue?vue&type=style&index=1&id=3fdb1343&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb1343",
  null
  
)

export default component.exports